import { Injectable } from '@angular/core';

import {ApiService} from './api.service';
import {StatusMap} from '../assignments/assignment.model';
import {UserService} from '../shared/user.service';
import {Notification} from './notification.model';
import {Utils} from '../utils';
    
@Injectable()
export class NotificationService {
    notifications = [];
    all = [];
    user;

    constructor(private api: ApiService, private userService: UserService, private utils: Utils) {
        this.user = api.getProp('user');
        const userSubscription = this.userService.user.subscribe(user => {
            this.loadNotifications();
            userSubscription.unsubscribe();
        });
    }
    comment(comment, assignment) {
        let message = this.getCommentMessage(comment, assignment);
        let notification = this.create(message, assignment);       
        this.notify(notification);
    }
    create(message, assignment) {
        let id = assignment.id;
        let user = this.user;
        return new Notification({
            assignment: id,
            editLink: '/slideshow/' + id,
            message: message,
            user: user,
            users: assignment.team
        });
    }
    filter(ids) {
        let filtered = this.notifications.filter(note => {
            let id = note.assignment;
            return ids.indexOf(id) !== -1;
        });
        this.notifications = filtered;
    }
    getCommentMessage(comment, assignment) {
        let user = this.user;
        let message = user.name + ' commented on ' + assignment.title + ' - "' + comment.content + '"';
        return message;
    }
    getStatusMessages(prev, status, assignment) {
        let messages = [];
        const team = assignment.team;
        let name = this.user.name;
        let title = assignment.title ? assignment.title : '(no title)';
        let writers = team.filter(item => item.hasOwnProperty('roles') && item.roles.indexOf('writer') !== -1);
        let pageAddWriters = team.filter(item => item.hasOwnProperty('roles') && item.roles.indexOf('pageAddWriter') !== -1);
        let editors = team.filter(item => item.hasOwnProperty('roles') && item.roles.indexOf('editor') !== -1);
        let date = this.utils.convertUtcDateToLocal(assignment.publishDate);
        switch(status) {
            case 'assigned':
                for(var i = 0; i < writers.length; i++) {
                    const message = name + ' assigned ' + writers[i].name + ' to ' + title;
                    messages.push(message);
                }  
                break;
            case 'sent_to_editor':
            case 'syn_sent_to_editor':
            case 'ready_to_delete_an':
            case 'ready_to_repost':
                for(var i = 0; i < editors.length; i++) {
                    const message = name + ' sent to ' + editors[i].name + ' for review ' + title;
                    messages.push(message);
                }     
                break;
            case 'revision_requested':
                messages.push(name + ' requested revisions for ' + title);
                break;
            case 'future':
                messages.push(name + ' scheduled to publish ' + title + ' on ' +  date);
                break;
            case 'add_assigned':
                for(var i = 0; i < pageAddWriters.length; i++) {
                    const message = name + ' assigned page additions to ' + pageAddWriters[i].name + ' for ' + title;
                    messages.push(message);
                }
                break;    
            case 'add_sent_to_editor':
                for(var i = 0; i < editors.length; i++) {
                    const message = name + ' sent page additions to ' + editors[i].name + ' for ' + title;
                    messages.push(message);
                }
                break;           
            case 'publish':
                messages.push(name + ' published ' + title);
                break;
            default:
                const message = title + ' status changed from ' + StatusMap[prev] + ' to ' + StatusMap[status] + '.';
                messages.push(message);
                break;
        }
        return messages;
    }
    loadNotifications() {
        const user = this.api.getProp('user');
        this.api.doAction('post', 'notifications', {
            action: 'read',
            id: user.id,
            per_page: 15,
            page: 1
        }).subscribe(
            data => {
                this.notifications = data;
                this.all = this.notifications;
            }
        );
    }
    mark(mark, i) {
        // user id needs to be a string so that it is treated like the slug intead of term_id
        let note = this.notifications[i];
        let userId = this.user.id + "";
        note[mark].push(userId);
        if( mark == 'dismissed' || mark == 'read' ) {
            this.notifications.splice(i, 1);
        }
        this.api.doAction('post', 'taxonomy', {
            action: 'update',
            id: note.id,
            terms: [
                {
                    taxonomy: 'dismissed',
                    terms: note.dismissed,
                    field: 'slug'
                },
                {
                    taxonomy: 'read',
                    terms: note.read,
                    field: 'slug'
                },
                {
                    taxonomy: 'unread',
                    terms: note.unread,
                    field: 'slug'
                }
            ]
        }).subscribe();
    }
    notify(args) {
        this.api.doAction('post', 'notify', args).subscribe(
            data => {
                this.notifications.unshift(data);
                if( this.notifications.length > 15 ) {
                    this.notifications.pop();
                }
            }
        );
    }
    reset() {
        this.notifications = this.all;
    }
    statusUpdate(prev, next, assignment) {
        let messages = this.getStatusMessages(prev, next, assignment);
        for(var i = 0; i < messages.length; i++) {
            const notification = this.create(messages[i], assignment); 
            this.notify(notification);
        }
    }
}
